module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./ExamListView.js"));
	}, "ExamListView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=ExamListView!./src/pages/Learn/Exam/ExamList/ExamListView.js
// module id = 1247
// module chunks = 431